import http from '../utils/request.js'

const getFeedbackItem = (param) => {
    return http.post('/feedback', { action: 'getFeedbackItem', param })
}
const createFeedback = (param) => {
    return http.post('/feedback', { action: 'creatFeedback', param })
}
export {
  getFeedbackItem,
  createFeedback
}